export default {
  body: {
    padding: 10,
  },
  icon: {
    verticalAlign: 'middle',
    marginRight: '10px',
    color: 'white',
    backgroundColor: '#b3b3b3',
    height: '40px',
    width: '40px',
    textAlign: 'center',
    paddingTop: '8px',
    borderRadius: '50%',
  },
  autocomplete: {
  },
  stageCol: {
    width: 200,
  },
  stageIcon: {
    width: 28,
    height: 28,
  },
};



// WEBPACK FOOTER //
// ./src/components/AssignEmployeesToStagesDialog/styles.js